export const getOrderedRecipientsArray = (recipients) => {
    const orderedRecipients = recipients.reduce((acc, recipient) => {
        const order = recipient.order || 0;
        const mapArray = acc[order] || [];
        return Object.assign(Object.assign({}, acc), { [order]: [...mapArray, recipient] });
    }, {});
    return Object.entries(orderedRecipients);
};
